<template>
  <BreadCrumbIndicator></BreadCrumbIndicator>

  <div class="my-4">
    <div v-if="!data">
      <SkeletonLoader class="h-10 w-1/3 mb-3"> </SkeletonLoader>
      <SkeletonLoader class="h-5 w-1/3"> </SkeletonLoader>
    </div>
    <div class="flex lg:flex-row flex-col lg:space-x-10" v-else>
      <div class="flex flex-col flex-grow mb-5 lg:mb-0">
        <h1 class="text-4xl font-semibold">{{ data.title }}</h1>
        <div v-if="data.reviews_count" class="flex items-center mt-2">
          <StarRating
            :reviews_count="data.reviews_count"
            :filled_stars="filledStars"
            :has_half_star="hasHalfStar"
            :rating="data.reviews_average"
          ></StarRating>
        </div>
        <div v-if="data.top_description" class="hidden lg:block">
          <div class="mt-6 ml-1 line-clamp-3 md:line-clamp-none relative">
            <div v-processlinks class="space-y-4 **:text-md" v-html="data.top_description"></div>
            <div
              class="absolute bottom-0 left-0 w-full h-12 bg-gradient-to-t from-white to-transparent md:hidden dark:from-[#121212]"
            ></div>
          </div>
          <a
            v-if="headlessContent"
            @click="scrollToGuide"
            class="ml-1 mt-1 float-right md:float-left underline cursor-pointer"
          >
            {{ $t('Read Full Guide') }}
          </a>
        </div>
      </div>
      <div v-if="data.top_description" class="order-1 lg:hidden">
        <div class="mt-6 ml-1 line-clamp-3 md:line-clamp-none relative">
          <div v-processlinks class="space-y-4" v-html="data.top_description"></div>
          <div
            class="absolute bottom-0 left-0 w-full h-12 bg-gradient-to-t from-white to-transparent md:hidden dark:from-[#121212]"
          ></div>
        </div>
        <a
          v-if="headlessContent"
          @click="scrollToGuide"
          class="ml-1 mt-1 float-right md:float-left underline cursor-pointer"
        >
          {{ $t('Read Full Guide') }}
        </a>
      </div>
      <!-- Lazy Load is false since google web vitals is recommending to DISABLE lazy loading for main images "Largest Contentful Paint image was lazily loaded" -->
      <SmartImg
        v-if="featured_image"
        id="identity-image"
        :lazyLoadImg="false"
        :src="featured_image"
        :alt="data.title"
        class="lg:w-2/5 w-full object-cover object-position-center mb-0 md:mb-5 h-[350px] md:h-[350px] rounded-lg bg-gray-300 dark:bg-gray-800 order-0 lg:order-1 float-right"
        :preload="true"
      />
    </div>
  </div>
</template>

<script setup>
const showFullText = ref(false);
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  headlessContent: {
    type: Boolean,
    default: false,
  },
});

let featured_image = props.data?.featured_image ?? ref(null);

// Computed properties for star rating
const filledStars = computed(() => Math.floor(props.data.reviews_average || 0));
const hasHalfStar = computed(() => (props.data.reviews_average || 0) - filledStars.value >= 0.5);

const scrollToGuide = () => {
  const section = document.getElementById('guide-section-wrapper');

  window.scrollTo({
    top: section.offsetTop - (window.innerWidth < 768 ? 30 : 100),
    behavior: 'smooth',
  });
};
</script>
